export const Types = {
  Visualizacao: 1,
  Edicao: 2
}